import React, {useState, useEffect} from "react";
import {db} from "../../utils/firebase";
import {collection, getDocs} from "firebase/firestore";
import {useNavigate} from "react-router-dom";
import img from "../../assets/img.jpg";

const Events = ({setIsPublic}) => {
	const navigate = useNavigate();
	const [events, setEvents] = useState([]);
	useEffect(() => {
		setIsPublic(false);
	}, []);

	useEffect(() => {
		const fetchData = async () => {
			try {
				const eventsRef = collection(db, "Events");
				const querySnapshot = await getDocs(eventsRef);

				const eventsArray = [];
				querySnapshot.forEach(doc => {
					const data = doc.data();
					eventsArray.push(data);
				});

				setEvents(eventsArray);
			} catch (error) {
				console.error("Error fetching data:", error);
			}
		};

		fetchData();
	}, []);

	console.log(events);

	return (
		<>
			<div class='container mx-auto p-4 flex items-center justify-center py-10'>
				<div class='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4'>
					{events?.map((e, index) => {
						return (
							<div
								class='max-w-sm mx-auto relative shadow-md rounded-lg cursor-pointer'
								onClick={() => {
									setIsPublic(true);
									navigate("/meet");
								}}
							>
								<img
									src={img}
									alt='Img by Meriç Dağlı https://unsplash.com/@meric'
									class='w-full h-auto object-cover rounded-lg'
								/>
								<div class='absolute bottom-0 left-0 right-0 h-40 bg-black bg-opacity-50 backdrop-blur text-white p-4 rounded-b-lg'>
									<h1 class='text-2xl font-semibold'>{e.topic}</h1>
									<p class='mt-2'>{e.description}</p>
								</div>
							</div>
						);
					})}
				</div>
			</div>
		</>
	);
};

export default Events;
